// extracted by mini-css-extract-plugin
export default {"safariClip":"util_safariClip__TcoNX","scrollbar":"util_scrollbar__0hJ67"};